import React from "react";
import Image from "@herb/components/Image";
import ReactHtmlParser from "react-html-parser";

import "./index.css";
import { fallbackImages } from "../../utils/constants";

const AriclePicture = ({ item, postTitle }) => {
  const { image, imageLink } = item;

  return (
    <div className="ImageForArticle">
      {imageLink ? (
        <a href={imageLink} target="_blank" rel="noreferrer">
          <Image
            className="lazyload ArticleMainImage"
            fallback={fallbackImages.square}
            src={(image || {}).sourceUrl}
            alt={(image || {}).altText || postTitle}
            width={816}
            height={448}
            imgixParams={{ fit: "clip" }}
          />
        </a>
      ) : (
        <Image
          className="lazyload ArticleMainImage"
          src={(image || {}).sourceUrl}
          fallback={fallbackImages.square}
          alt={(image || {}).altText || postTitle}
          width={816}
          height={448}
          imgixParams={{ fit: "clip" }}
        />
      )}
      <div className="articleImageCredits">
        <div className="imageCourtesy">
          {ReactHtmlParser((image || {}).caption)}
        </div>
      </div>
    </div>
  );
};

export default AriclePicture;
